import { InjectionToken, Signal, signal } from '@angular/core';

export type SiteTimeZoneContext = Signal<string | undefined>;

export const SITE_TIME_ZONE = new InjectionToken<SiteTimeZoneContext>('SITE_TIME_ZONE', {
  factory: () => signal<string | undefined>(undefined).asReadonly(),
});
